module.exports = __webpack_public_path__ + "static/media/SM-ST-8.fab896f2.mp3";